export const SELECT_PRESCRIBE = "prescribe/SELECT_PRESCRIBE";

export const GET_ALL_PRESCRIBE_REQUEST = "prescribe/GET_ALL_PRESCRIBE_REQUEST";
export const GET_ALL_PRESCRIBE_SUCCESS = "prescribe/GET_ALL_PRESCRIBE_SUCCESS";
export const GET_ALL_PRESCRIBE_FAILURE = "prescribe/GET_ALL_PRESCRIBE_FAILURE";

export const GET_DETAIL_PRESCRIBE_BY_DATE_REQUEST =
  "prescribe/GET_DETAIL_PRESCRIBE_BY_DATE_REQUEST";
export const GET_DETAIL_PRESCRIBE_BY_DATE_SUCCESS =
  "prescribe/GET_DETAIL_PRESCRIBE_BY_DATE_SUCCESS";
export const GET_DETAIL_PRESCRIBE_BY_DATE_FAILURE =
  "prescribe/GET_DETAIL_PRESCRIBE_BY_DATE_FAILURE";

export const SHOW_LOADING = "prescribe/SHOW_LOADING";
export const HIDE_LOADING = "prescribe/HIDE_LOADING";
